module.exports = __webpack_public_path__ + "img/404.1970f6f5.svg";